<template>
  <fieldset
    :class="['language-radio-group', { 'language-radio-group--horizontal': horizontal }]"
    :data-testid="testId || null"
    :disabled="disabled"
    :aria-label="horizontal && showLabel ? 'Bahasa' : null"
  >
    <legend v-if="showLabel && !horizontal" class="language-radio-group__legend">Bahasa:</legend>
    <span
      v-else-if="showLabel"
      class="language-radio-group__legend language-radio-group__legend--inline"
    >Bahasa:</span>

    <div class="language-radio-group__options">
      <CInputRadio
        :id="`${idPrefix}-indonesia`"
        :data-testid="testId ? `${testId}-indonesia` : null"
        :name="name"
        value="indonesia"
        label="Indonesia"
        :inline="true"
        :checked="value === 'indonesia'"
        :disabled="disabled"
        @change="select('indonesia', $event)"
      />
      <CInputRadio
        :id="`${idPrefix}-english`"
        :data-testid="testId ? `${testId}-english` : null"
        :name="name"
        value="english"
        label="English"
        :inline="true"
        :checked="value === 'english'"
        :disabled="disabled"
        @change="select('english', $event)"
      />
    </div>
  </fieldset>
</template>

<script>
import { CInputRadio } from '@coreui/vue'

export default {
  name: 'LanguageRadioGroup',
  components: { CInputRadio },
  props: {
    value: {
      type: String,
      required: true,
      validator: (val) => ['indonesia', 'english'].includes(val),
    },
    name: {
      type: String,
      required: true,
    },
    idPrefix: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    testId: {
      type: String,
      default: '',
    },
    showLabel: {
      type: Boolean,
      default: true,
    },
    horizontal: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    select(value, event) {
      if (this.disabled || value === this.value) return
      this.$emit('input', value)
      this.$emit('change', value, event)
    },
  },
}
</script>

<style scoped>
.language-radio-group {
  min-width: 0;
  margin: 0;
  padding: 0;
  border: 0;
}

.language-radio-group__legend {
  width: auto;
  margin-bottom: 0.5rem;
  font-size: inherit;
  line-height: inherit;
  font-weight: 400;
}

.language-radio-group__options {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.language-radio-group--horizontal {
  display: flex !important;
  width: 100%;
  align-items: baseline;
}

.language-radio-group--horizontal .language-radio-group__legend--inline {
  flex: 0 0 25%;
  margin: 0;
  padding-right: 1rem;
}

.language-radio-group--horizontal .language-radio-group__options {
  display: flex !important;
  flex: 1 1 auto;
  min-width: 0;
  gap: 3rem;
}

</style>
